// extracted by mini-css-extract-plugin
module.exports = {"modal":"InvitationModal_modal__eqhTf","card":"InvitationModal_card__3IuP1","card_info":"InvitationModal_card_info__3YU-S"};